module.exports = __webpack_public_path__ + "static/media/Zapier-First-Image.3811c3e2.jpg";